<template>
  <div class="general-wrapper">
    <Header>
      <template #title>
        Facebook
      </template>
    </Header>

    <PageContainer>
      <div class="iqos-grid">
        <div class="iqos-column" v-if="selected == 'facebook'">
           <FacebookPixelPanel />
        </div>
      </div>
    </PageContainer>
  </div>
</template>

<script>
import FacebookPixelPanel from "@/components/integrations/FacebookPixelPanel.vue";

export default {
  data() {
    return {
      selected: "facebook",
      orderIntegration: false,
    };
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
  },
  mounted() {
    this.selected = this.$route.params.id;
  },
  components: {
    FacebookPixelPanel,
  },
};
</script>

<style scoped>
</style>